module.exports = __webpack_public_path__ + "pin_yellow.ef94de.png";